import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { BaseProps, TabsType } from '../common/props';

type DefaultTabsProps = BaseProps & { type?: TabsType };
export const Tabs: React.FC<DefaultTabsProps> = ({
  className,
  style,
  children,
  type,
}) => {
  return (
    <div
      className={classNames(Classes.TABS, className, {
        [Classes.TABS_DEFAULT]: !type || type === 'default',
        [Classes.TABS_PROCESS]: type === 'process',
      })}
      style={style}
    >
      {children}
    </div>
  );
};
